import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import axios, { CancelTokenSource } from "axios";

import { RootState } from "src/redux/reducers";
import { wsAxiosPost } from "src/helpers/wsAxios";
import { API_URLS } from "src/utils/API_URLS";
import Loader from "src/app/components/Loader/Loader";
import { showErrorToast } from "src/utils/methods";
import generateUuid from "src/app/libs/generateUuid";
import { usePageTitle } from "src/app/title-management/usePageTitle";

export default function CampaignCreatorSearch() {
  usePageTitle("Creator Search");

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const history = useHistory();

  const cancelToken = useRef<CancelTokenSource | null>(null);

  const abortCreateResearchProject = () => {
    cancelToken.current?.cancel();
  };

  useEffect(() => {
    const createProject = async () => {
      abortCreateResearchProject();
      cancelToken.current = axios.CancelToken.source();

      setLoading(true);
      const newUuid = generateUuid();

      try {
        await wsAxiosPost(
          API_URLS.createResearchCreatorProject,
          {
            wsProjectUuid: newUuid,
            wsWorkspaceUuid: activeWorkspaceUuid,
          },
          "Cannot create project",
        );

        history.replace(
          `/workspace/${activeWorkspaceUuid}/projects/${newUuid}?tab=creatorSearch`,
        );
      } catch (e) {
        console.error(e);
        if (axios.isCancel(e)) return;
        showErrorToast({
          id: "ws_error_creating_research",
          defaultMessage: "Error creating research",
        });
        history.push(`/workspace/${activeWorkspaceUuid}`);
      }
    };

    createProject();
  }, [activeWorkspaceUuid, history]);

  useEffect(() => {
    return () => {
      abortCreateResearchProject();
    };
  }, []);

  if (loading) {
    return <Loader />;
  }
  return null;
}
